import './QuoteDeviceApprovalCardSkeleton.scss';

/** Skeleton de carga para la card de dispositivo cotizado con aprobación del cliente */
const QuoteDeviceApprovalCardSkeleton = () => {
  const bottomCols = [1, 2, 3, 4, 5];

  return (
    <div className="quoteDeviceApprovalCardSkeleton">
      <div className="cardTop">
        <div className="productLeft">
          <div className="imageSkeleton animationLoader" />
          <div className="productInfo">
            <div className="nameSkeleton animationLoader" />
            <div className="tagsSkeleton">
              <div className="tagSkeleton animationLoader" />
              <div className="tagSkeleton animationLoader" />
              <div className="tagSkeleton animationLoader" />
            </div>
          </div>
        </div>
        <div className="productMeta">
          {[80, 60, 90].map(w => (
            <div key={w} className="metaCol">
              <div className="metaLabelSkeleton animationLoader" />
              <div className="metaValueSkeleton animationLoader" style={{ width: `${w / 10}rem` }} />
            </div>
          ))}
        </div>
      </div>
      <div className="cardBottomContainer">
        <div className="cardBottom">
          {bottomCols.map(i => (
            <div key={i} className="bottomCol">
              <div className="bottomLabelSkeleton animationLoader" />
              <div className="bottomValueSkeleton animationLoader" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default QuoteDeviceApprovalCardSkeleton;
